import { Injectable } from '@angular/core';
import {FileUploader} from 'ng2-file-upload';
import {environment} from '../../environments/environment';

@Injectable()
export class FileUploadFactoryService {

  static uploadUrl() {
    return `${environment.apiUrl}/upload`;
  }

  constructor() { }

  create(fileName: string, url: string): FileUploader {
    let uploader = new FileUploader({
      itemAlias: fileName,
      autoUpload: true,
      authToken: `Basic ${localStorage.getItem('authorization')}`,
      url: url});
    uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });
    return uploader;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/file-upload-factory.service.ts